import type { IconProps } from '@src/components/icons/IconProps';

/** Small card mark — participant tile meta pill. */
export function IdCardIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 10.5h18V20H3zM2.5 7h19v3.5h-19zM12 7v14" />
    </svg>
  );
}
